module.exports = __webpack_public_path__ + "img/24.26af6b4d.jpg";